import { idX } from "@insightfulscience/shared-utils/fn";
import { createItemStorage } from "../../utils/createItemStorage";

export const token = ({ storage }) =>
	createItemStorage(storage, "token", { expires: 365 }, idX, idX);
